import hoistNonReactStatics from 'hoist-non-react-statics';
import React, { useCallback } from 'react';

import { Select, normalizeSelectValue } from '@gogame/components';

import { omitFormProps } from '../utils';
import withFormField from './withFormField';

const EMPTY_OPTIONS = [];

const normalizeValue = (value, options) => {
  if (options.length === 1) {
    return options[0].id;
  }
  return normalizeSelectValue(value, options);
};

const RELOAD_DELAY = 500;

const FormSelect = withFormField({ normalizeValue })(
  ({ area, onAdd, ...props }) => {
    const handleOnAdd = onAdd
      ? useCallback(
          async (e) => {
            const option = await onAdd(area);
            await new Promise((resolve) => setTimeout(resolve, RELOAD_DELAY));
            await area.reload();
            await props.onChange(e, option?.id);
          },
          [onAdd, area]
        )
      : null;

    return (
      <Select
        loading={area.loading}
        options={area.data || EMPTY_OPTIONS}
        onAdd={handleOnAdd}
        {...omitFormProps(props)}
      />
    );
  }
);

export default hoistNonReactStatics(FormSelect, Select, { Virtual: true });
